import * as React from 'react';

import * as CommonUx from '@abb/common-ux';

interface IAdditionalQuestionsProps {
  condition: string; 
  downtime: string; 
  storage: string; 
  awareness: string;
  email: string;
  validationStateCondition: CommonUx.VALIDATION_STATE;
  validationStateDowntime: CommonUx.VALIDATION_STATE;
  validationStateStorage: CommonUx.VALIDATION_STATE;
  validationStateAwareness: CommonUx.VALIDATION_STATE;
  onChangeCondition: (opt: CommonUx.Option) => void;
  onChangeDowntime: (opt: CommonUx.Option) => void;
  onChangeStorage: (opt: CommonUx.Option) => void;
  onChangeAwareness: (opt: CommonUx.Option) => void;
}

export const AdditionalQuestions: React.SFC<IAdditionalQuestionsProps> = (props: IAdditionalQuestionsProps) => {
  return (
    <div>
      <div className='row'>
        <div className='col-sm-12'>
          <CommonUx.ComboBox
            labelText='Do you know the condition and location of all of your spare parts?'
            size='default'
            required={true}
            searchable={false}
            options={[{ label: '', value: '' }, { label: 'Yes', value: 'Yes' }, { label: 'Some', value: 'Some' }, { label: 'No', value: 'No' }]}
            value={props.condition}
            validationState={props.validationStateCondition}
            onChange={props.onChangeCondition}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12'>
          <CommonUx.ComboBox
            labelText='Have you had downtime from missing or failed parts?'
            size='default'
            required={true}
            searchable={false}
            options={[{ label: '', value: '' }, { label: 'Never', value: 'Never' }, { label: 'Occasionally', value: 'Occasionally' }, { label: 'Often', value: 'Often' }]}
            value={props.downtime}
            validationState={props.validationStateDowntime}
            onChange={props.onChangeDowntime}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12'>
          <CommonUx.ComboBox
            labelText='Are your spare parts kept in sealed static bags and / or sealed boxes?'
            size='default'
            required={true}
            searchable={false}
            options={[{ label: '', value: '' }, { label: 'Yes', value: 'Yes' }, { label: 'Some', value: 'Some' }, { label: 'No', value: 'No' }]}
            value={props.storage}
            validationState={props.validationStateStorage}
            onChange={props.onChangeStorage}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12'>
          <CommonUx.ComboBox
            labelText='Are you aware of all the options and programs ABB has available for spare parts?'
            size='default'
            required={true}
            searchable={true}
            options={[{ label: '', value: '' }, { label: 'Yes', value: 'Yes' }, { label: 'Some', value: 'Some' }, { label: 'No', value: 'No' }]}
            value={props.awareness}
            validationState={props.validationStateAwareness}
            onChange={props.onChangeAwareness}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 note'>
          <span>You are submitting your request for the full parts analysis report. When ready, your report link will be emailed to:</span>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 note' style={{paddingTop: '10px'}}>
          <span>{props.email}</span>
        </div>
      </div>
    </div>
  );
};
